import {
  GroupByMode,
  ID,
  overdueSectionID,
  ReorderSectionUpdate,
  SortingMode,
  UserSettings,
} from '@griply/types';

import { formatDateKey } from './format-date-key';

export type BuildUpcomingReorderUserSettingsOptions = {
  updatedSections: ReorderSectionUpdate[];
  today: Date;
};

export const buildUpcomingReorderUserSettings = ({
  updatedSections,
  today,
}: BuildUpcomingReorderUserSettingsOptions): Partial<UserSettings> | null => {
  const newOrder = updatedSections.reduce<Record<ID, ID[]>>((acc, section) => {
    if (section.id === overdueSectionID) {
      return acc;
    }
    acc[section.id] = section.taskSorting;
    return acc;
  }, {});

  if (!Object.keys(newOrder).length) {
    return null;
  }

  // Today's section keeps its real legacy value: it is the only channel Today's
  // `None` order is reconstructed from, and Today never reads the upcoming slot.
  const todayKey = formatDateKey(today);

  // Firestore stores these nulls literally; the user converter drops them on read
  const legacyTodoSorting = Object.keys(newOrder).reduce<Record<string, ID[]>>(
    (acc, key) => {
      acc[key] = key === todayKey ? newOrder[key] : (null as unknown as ID[]);
      return acc;
    },
    {},
  );

  return {
    customTaskOrder: {
      upcoming: { [GroupByMode.UpcomingDeadline]: newOrder },
    },
    // Upcoming owns its sort independently of Today's global `todoSortingMode`,
    // so reordering only flips Upcoming to Custom — Today's sort is untouched.
    upcoming: { sortingMode: SortingMode.Custom },
    todoSorting: legacyTodoSorting,
  };
};
